import { map, pluck } from 'rxjs/operators'
import { DocsType } from '../../../actions/docs/docsTypes'
import { ofType, ActionsObservable } from 'redux-observable'
import { ReduxAction } from '../../../reducers/reducerType'
import { setQuestionsInitialState } from '../../../actions/questions/questions'

const setQuestionsInitialState$ = (actions$: ActionsObservable<ReduxAction>) => actions$.pipe(
  ofType(DocsType.SET_QUESTIONS_DOCUMENT),
  pluck('payload'),
  pluck('data'),
  map((doc) => setQuestionsInitialState(doc))
)

export default setQuestionsInitialState$
